import ally from 'ally.js/ally';
import * as helpers from '../helpers';
import SlideToggler from './slideToggler';

/*
* TODO: finish open state
* TODO: REFACTOR
* TODO: possibility to add overlay
* */

/**
 * Class represents Dropdown component
 */
export default class Dropdown {
    /**
     * Create dropdown instance.
     * @param {(String|Node)} selector - element to initialize plugin
     * @param {Object} options - Dropdown options
     */
    constructor(selector = '.js-dropdown', options = null) {
        this.selector = selector;
        this.toggler = null;
        this.dropdown = null;
        this.slideToggler = null;
        this.closeBtn = null;
        this.focusTrapHandler = null;
        this.dropdowmWidth = null;
        this.keyOptions = null;
        window.dropdownList = window.dropdownList || {};

        // Plugin options
        this.options = {
            wrapperClass: 'js-dropdown',
            dropdownClass: 'js-dropdown__block',
            btnClass: 'js-dropdown__toggle',
            closeBtnClass: 'js-dropdown__close',
            closeBtnHtml: '<span class="ghost">Fermer</span>',
            closeHelperClass: 'has-close-btn',
            closeBtn: false,
            opened: [],
            outsideToggle: false,
            outsideToggleId: 'js-dropdown-outside-toggle',
            closeOnOutsideClick: true,
            openTypeSlide: false,
            isWrapContent: false,
            focusTrap: true,
            overflow: false,
            clickRoll: false,
            disabledClose: [],
            onInit: (instance) => {
            },
            afterInit: (instance) => {
            },
            beforeOpen: (instance) => {
            },
            afterOpen: (instance) => {
            },
            beforeClose: (instance) => {
            },
            afterClose: (instance) => {
            },
        };

        if (options instanceof Object) {
            this.options = helpers.extendDefaults(this.options, options);
        }

        this.$nextKeysHandler = this.nextKeysHandler.bind(this);

        this.$prevKeysHandler = this.prevKeysHandler.bind(this);

        this.$outsideHandler = this.outsideHandler.bind(this);

        this.$escHandler = this.escHandler.bind(this);

        this.checkBeforeInit();
    }

    static onTogglerClick() {
        let flag;
        if (this.options.outsideToggle) {
            flag = helpers.hasClass(this.selector, '-is-open');
        } else {
            flag = helpers.hasClass(this.toggler.parentElement, '-is-open');
        }
        if (flag === true) {
            this.close();
        } else {
            this.open();
        }
    }

    checkBeforeInit() {
        if (typeof this.selector !== 'string') {
            if (helpers.hasClass(this.selector, '-is-initialized')) {
                return;
            }
            return this.selector === null ? false : this.init();
        }

        if (typeof this.selector === 'string') {
            const els = document.querySelectorAll(this.selector);

            if (els === null) {
                return;
            }

            for (let i = 0; i < els.length; i++) {
                const el = new Dropdown(els[i], this.options);
            }
        }
    }

    init() {
        this.options.onInit(this.selector);
        this.create();
        this.initEvents();
        this.saveToStorage();
        this.options.afterInit(this.selector);
    }

    saveToStorage() {
        const dropdownId = helpers.getUniqId();
        this.selector.setAttribute('data-dropdown-id', dropdownId);
        window.dropdownList[dropdownId] = this;
    }

    manageResponsiveState() {
        if (this.options.opened.length === 0) {
            return;
        }

        const isOpened = helpers.hasClass(this.selector, '-is-open');
        const isNeedToOpen = this.options.opened.indexOf(window.responsive) !== -1;

        if (!isOpened && isNeedToOpen) {
            this.open();
        } else if (isOpened && !isNeedToOpen) {
            // Don't close the menu when changing the height
            if (this.selector.getBoundingClientRect().height !== 0 && this.menuWidth !== this.selector.getBoundingClientRect().width) {
                this.close();
            }
        }
    }

    create() {
        const $selector = this.selector;
        let errSelector = '';

        helpers.addClass($selector, '-is-initialized');
        $selector.classList.add(this.options.wrapperClass);

        if (this.options.outsideToggle) {
            this.toggler = document.getElementById(this.options.outsideToggleId);
            errSelector = `"#${this.options.outsideToggleId}"`;
        } else {
            this.toggler = $selector.querySelector(`.${this.options.btnClass}`);
            errSelector = `".${this.options.btnClass}"`;
        }

        // Handle if toggler button not found.
        if (!this.toggler) {
            throw new Error(`Dropdown. Can't find toggle button with selector: ${errSelector} for "${this.selector.className}"`);
        }

        this.dropdown = $selector.querySelector(`.${this.options.dropdownClass}`);

        if (this.options.opened.length === 0) {
            helpers.setTabindex(this.dropdown, -1);
        } else {
            helpers.setTabindex(this.dropdown, 0);
        }

        this.slideToggler = this.options.openTypeSlide && new SlideToggler(this.dropdown, {
            isWrapContent: this.options.isWrapContent,
        });

        if (this.options.closeBtn) {
            this.closeBtn = $selector.querySelector(`.${this.options.closeBtnClass}`);

            // Check if $close button is not exists
            if (this.closeBtn === null) {
                this.closeBtn = document.createElement('button');
                this.closeBtn.setAttribute('type', 'button');
                this.closeBtn.className = this.options.closeBtnClass;
                this.closeBtn.innerHTML = this.options.closeBtnHtml;
                $selector.insertBefore(this.closeBtn, $selector.children[0]);
            }

            helpers.initAriaControls([this.toggler, this.closeBtn], this.dropdown);
        } else {
            helpers.initAriaControls(this.toggler, this.dropdown);
        }
    }

    tooltipEvent() {
        const tooltip = document.querySelector('#access-tooltip');

        if (tooltip) {
            const computedStyle = getComputedStyle(tooltip);

            if (computedStyle.display === 'block') {
                tooltip.style.display = 'none';
            } else {
                tooltip.style.display = 'block';
            }
        }
    }

    open() {
        this.menuWidth = this.selector.getBoundingClientRect().width;
        this.options.beforeOpen();

        if (this.options.openTypeSlide) {
            this.slideToggler.open();
        }

        if (this.options.outsideToggle) {
            helpers.addClass(this.selector, '-is-open');
        } else {
            helpers.addClass(this.toggler.parentElement, '-is-open');
        }
        if (this.options.closeBtn === true && this.closeBtn !== null) {
            helpers.setAriaControls([this.toggler, this.closeBtn], this.dropdown, 'opened');
            this.closeBtn.setAttribute('tabindex', 0);
        } else {
            helpers.setAriaControls(this.toggler, this.dropdown, 'opened');
        }

        if (this.options.overflow) {
            helpers.addClass(document.body, '-overflow-hidden');
        }

        this.keyOptions = {
            context: this.selector,
        };

        if (this.options.focusTrap && !this.options.clickRoll) {
            this.toggler.setAttribute('tabindex', 0);
            this.keyOptions.tab = this.$nextKeysHandler;
            this.keyOptions['shift+tab'] = this.$prevKeysHandler;
        }

        if (!this.options.clickRoll) {
            this.keyOptions.down = this.$nextKeysHandler;
            this.keyOptions.right = this.$nextKeysHandler;
            this.keyOptions.up = this.$prevKeysHandler;
            this.keyOptions.left = this.$prevKeysHandler;
            this.keyOptions.escape = this.$escHandler;
            this.$keyHandler = ally.when.key(this.keyOptions);
        }

        if (this.options.focusTrap) {
            this.focusTrapHandler = this.initFocusTrap.bind(this);
            window.addEventListener('responsive', this.manageFocusTrap.bind(this), false);
        }

        this.$tabindexHandler = ally.when.visibleArea({
            context: this.dropdown,
            callback: (el) => {
                helpers.setTabindex(this.dropdown, 0);
            },
            area: 0.5, // change it if you have problems with tabindex.
        });

        this.tooltipEvent();
        this.options.afterOpen(this.selector);
    }

    escHandler(event) {
        event.preventDefault();
        event.stopPropagation();
        let flag = false;

        this.options.disabledClose.forEach((resp) => {
            if (resp === window.responsive) {
                flag = true;
            }
        });

        if (!flag) {
            this.close();
        }
    }

    close() {
        this.options.beforeClose(this.selector);

        // When closed set focus on opener button
        if (this.options.focusTrap) {
            this.toggler.focus();
            this.toggler.removeAttribute('tabindex');
        }

        if (this.options.openTypeSlide) {
            this.slideToggler.close();
        }
        if (this.options.outsideToggle) {
            helpers.removeClass(this.selector, '-is-open');
        } else {
            helpers.removeClass(this.toggler.parentElement, '-is-open');
        }

        if (this.options.overflow) {
            helpers.removeClass(document.body, '-overflow-hidden');
        }

        this.disengageAllyHandlers();

        helpers.setTabindex(this.dropdown, -1);

        if (this.options.closeBtn === true && this.closeBtn !== null) {
            helpers.setAriaControls([this.toggler, this.closeBtn], this.dropdown, 'closed');
            this.closeBtn.setAttribute('tabindex', -1);
        } else {
            helpers.setAriaControls(this.toggler, this.dropdown, 'closed');
        }

        this.tooltipEvent();
        this.options.afterClose(this.selector);
    }

    skipFormControls(element) {
        let skip = true;

        if (element) {
            const tagName = element.tagName.toLowerCase();
            const type = element.getAttribute('type');

            switch (tagName) {
                case 'input':
                    if (type && type !== 'radio' && type !== 'checkbox' && type !== 'date') {
                        skip = false;
                    }

                    break;
                case 'textarea':
                    skip = false;
                    break;
                default:
            }
        }

        return skip;
    }

    nextKeysHandler(event) {
        if (this.skipFormControls(event.target)) {
            event.preventDefault();
            if (this.selector && typeof this.selector === 'object') {
                const nextElement = helpers.getNextFocusableElement(event.target, this.selector);

                if (nextElement) {
                    ally.element.focus(nextElement);
                }
            }
        }
    }

    prevKeysHandler(event) {
        if (this.skipFormControls(event.target)) {
            event.preventDefault();
            if (this.selector && typeof this.selector === 'object') {
                const prevElement = helpers.getPrevFocusableElement(event.target, this.selector);

                if (prevElement) {
                    ally.element.focus(prevElement);
                }
            }
        }
    }

    /**
     * Remove allyjs handlers.
     */
    disengageAllyHandlers() {
        if (this.$keyHandler) {
            this.$keyHandler.disengage();
        }

        if (this.$tabindexHandler) {
            this.$tabindexHandler.disengage();
        }
    }

    initEvents() {
        this.toggler.addEventListener('click', helpers.debounce(Dropdown.onTogglerClick.bind(this), 200));

        if (this.options.closeBtn === true && this.closeBtn !== null) {
            this.closeBtn.addEventListener('click', this.close.bind(this));
        }

        window.addEventListener('responsive', this.manageResponsiveState.bind(this));

        // Close dropdown if click outside
        if (this.options.closeOnOutsideClick) {
            document.addEventListener('click', (event) => {
                const isClickInside = this.selector.contains(event.target) || event.target === this.toggler || this.toggler.contains(event.target);
                const isOpened = helpers.hasClass(this.selector, '-is-open');

                if (!isClickInside && isOpened) {
                    this.close();
                }
            });
        }
    }

    /**
     * Handle outside clicks.
     */
    outsideHandler(event) {
        if (this.selector && typeof this.selector === 'object' && this.toggle) {
            const isCorrectClick = this.selector.contains(event.target) || event.target === this.toggler || this.toggler.contains(event.target);
            const isOpened = helpers.hasClass(this.selector, this.options.classList.opened);

            if (!isCorrectClick && isOpened) {
                this.close();
            }
        }
    }

    manageFocusTrap() {
        if (typeof this.options.focusTrap !== 'boolean') {
            if (!Array.isArray(this.options.focusTrap)) {
                throw new Error('focusTrap parameter should be Boolean or Array');
            }

            this.selector.removeEventListener('keydown', this.focusTrapHandler, true);
            this.options.focusTrap.forEach((resolution) => {
                if (window.responsive === resolution) {
                    this.selector.addEventListener('keydown', this.focusTrapHandler, true);
                }
            });
        } else {
            this.selector.addEventListener('keydown', this.focusTrapHandler, true);
        }
    }

    initFocusTrap(event) {
        helpers.initFocusTrap(this.selector, event, true);
    }

    destroy() {
        helpers.removeAriaControls(this.toggler.parentElement);
        this.toggler.removeEventListener('click', Dropdown.onTogglerClick.bind(this));

        if (this.options.closeBtn === true && this.closeBtn !== null) {
            this.closeBtn.removeEventListener('click', this.close.bind(this));
        }
    }
}
